type Crumb = { label: string; to?: string };

type PageHeaderProps = {
  breadcrumbs: Crumb[];
  title: string;
  subtitle?: string;
  image: string;
  alt: string;
};

export default function PageHeader({ breadcrumbs, title, subtitle, image, alt }: PageHeaderProps) {
  return (
    <section className="relative flex min-h-[320px] w-full items-center overflow-hidden pt-20 md:min-h-[380px]">
      <div className="absolute inset-0">
        <img src={image} alt={alt} className="h-full w-full object-cover" />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/75 via-foreground-950/55 to-foreground-950/80"></div>
      <div className="relative z-10 mx-auto w-full max-w-7xl px-4 pb-12 pt-8 md:px-6">
        <nav
          aria-label="面包屑"
          className="flex flex-wrap items-center gap-1.5 text-xs text-background-200/80"
        >
          {breadcrumbs.map((item, idx) => {
            const isLast = idx === breadcrumbs.length - 1;
            return (
              <span key={item.label} className="flex items-center gap-1.5">
                {item.to && !isLast ? (
                  <a href={item.to} className="transition-colors hover:text-accent-300">
                    {item.label}
                  </a>
                ) : (
                  <span className={isLast ? "text-accent-300" : "text-background-300"}>
                    {item.label}
                  </span>
                )}
                {!isLast && <i className="ri-arrow-right-s-line" />}
              </span>
            );
          })}
        </nav>
        <h1 className="mt-4 font-heading text-3xl font-black text-background-50 md:text-4xl">{title}</h1>
        {subtitle && (
          <p className="mt-4 max-w-2xl text-sm leading-relaxed text-background-100/85 md:text-base">
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
}